import React, { Component } from 'react';
//import IdleTimer from 'react-idle-timer';
import { withTranslation } from 'react-i18next';
import AdviserPortal from './AdviserPortal';
import StaticHeader from './StaticHeader';
import ErrorBoundary from './ErrorBoundary';
//import { Container, Row, Col } from 'react-bootstrap';

class KeycloakLogin extends Component {

  // constructor(props) {
  //   super(props);
  //   this.idleTimer = null;
  idleTimer = null;
  state = { 
      loading: true,
      // timeout: 1000 * 5 * 1,
      // timedOut: false
    };
  //}

  // onAction(){
  //   this.setState({timedOut: false})
  // }

  // onActive(){
  //   this.setState({timedOut: false})
  // }

  // onIdle(){
  //   const isTimedOut = this.state.timedOut;
  //   if(isTimedOut){
  //     this.props.history.push("/adv/login");
  //     this.props.keycloak.logout();
  //   }
  //   else{
  //     this.idleTimer.reset();
  //     this.setState({isTimedOut: true});
  //     this.props.history.push("/adv/login");
  //     this.props.keycloak.logout();
  //   }
  // }

  componentDidMount() {
    this.props.loginToKeycloak()
  }

  render() {
    const {t} = this.props
    if (this.props.keycloak) {
      if (this.props.authenticated) 
      return (
        <div>
          <ErrorBoundary>
          {/* <Container>
            <Row>
              <Col><StaticHeader keycloak={this.props.keycloak} {...this.props}/></Col>
              <Col><AdviserPortal {...this.props}/></Col>
            </Row>
          </Container> */}
          <StaticHeader keycloak={this.props.keycloak} {...this.props}/>
          {/* <div style={{marginLeft: "100px", marginRight: "100px"}}> */}
          <AdviserPortal {...this.props}/>
          {/* </div> */}
          </ErrorBoundary>
          {/* <IdleTimer ref={ref => this.idleTimer = ref} element={document} 
            onAction={this.onAction} onActive={this.onActive} onIdle={this.onIdle}
            debounce={250} timeout={this.state.timedOut}
           /> */}
        </div>
      ); else return (<div>{t('adviserHomePage:unabletoAuthenticate')}</div>)
    }
    return (
      <div>{t('adviserHomePage:initialize')}</div>
    );
  }
}
export default withTranslation()(KeycloakLogin);